
import React from 'react';
import { User, MessageSquare, Settings, LayoutDashboard, Store, Users, BarChart3, Trophy } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';

interface BottomNavigationProps {
  userType: 'breeder' | 'buyer' | 'admin';
  activeSection: string;
  onSectionChange: (section: string) => void;
  subscriptionActive?: boolean;
}

export const BottomNavigation = ({ 
  userType, 
  activeSection, 
  onSectionChange, 
  subscriptionActive = true 
}: BottomNavigationProps) => {
  const navigate = useNavigate();

  const getMenuItems = () => {
    switch (userType) {
      case 'admin':
        return [
          { id: 'statistics', label: 'Stats', icon: BarChart3 },
          { id: 'users', label: 'Users', icon: Users },
          { id: 'top-auctions', label: 'Auctions', icon: Trophy },
        ];
      case 'breeder':
        return [
          { id: 'profile', label: 'Profile', icon: LayoutDashboard },
          { id: 'messages', label: 'Messages', icon: MessageSquare },
          { id: 'settings', label: 'Settings', icon: Settings }
        ];
      case 'buyer':
        return [
          { id: 'profile', label: 'Profile', icon: LayoutDashboard },
          { id: 'messages', label: 'Messages', icon: MessageSquare }
        ];
      default:
        return [];
    }
  };

  const menuItems = getMenuItems();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 md:hidden">
      <div className="flex justify-around items-center">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onSectionChange(item.id)}
            className={cn(
              "flex flex-col items-center space-y-1 px-3 py-2 rounded-lg transition-colors",
              activeSection === item.id 
                ? "bg-green-100 text-green-700" 
                : "text-gray-600 hover:text-gray-900"
            )}
          >
            <item.icon className="w-5 h-5" />
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
        
        {userType !== 'admin' && (
          <button
            onClick={() => navigate('/marketplace')}
            className="flex flex-col items-center space-y-1 px-3 py-2 rounded-lg transition-colors text-green-700 hover:bg-green-50"
          >
            <Store className="w-5 h-5" />
            <span className="text-xs font-medium">Marketplace</span>
          </button>
        )}
      </div>
    </div>
  );
};
